import * as styles from "./DataTable.styles";

type Row = string[];

type Props = {
  headers: string[];
  rows: Row[];
};

const DataTable = ({ headers, rows }: Props) => {
  return (
    <div css={styles.scrollWrapper}>
      <table css={styles.table}>
        <thead>
          <tr>
            {headers.map(header => (
              <th key={header} css={styles.headerCell}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td key={`${rowIndex}-${cellIndex}`} css={styles.cell}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export { DataTable };
